export default function WhyDeerPoint() {
  const features = [
    {
      icon: 'ri-tools-fill',
      title: 'Full-Service Capability',
      description: 'From exteriors and interiors to storefront and government contracting, we handle every scope of work in-house. Owners and general contractors trust us to deliver complete solutions, not just pieces of the puzzle.',
    },
    {
      icon: 'ri-building-fill',
      title: 'Multifamily Expertise',
      description: 'Our leadership team has built and renovated over 3,600 apartment units across the country. We understand the renovation needs of institutional investors, developers, and property managers pursuing value-add strategies.',
    },
    {
      icon: 'ri-hospital-fill',
      title: 'Expanding Into Senior Living',
      description: 'We are bringing our proven renovation capabilities into an underserved market: senior living and healthcare facilities. Memory care centers, nursing homes, and assisted living communities deserve the same quality and professionalism we deliver to our multifamily clients.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-[#2C2C2C] mb-16 text-center">
          Why Deer Point
        </h2>
        <div className="grid md:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-[#C5A55A] rounded-lg mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}